export default "__VITE_ASSET__3a5738c7__"